document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCountUp();
  initTiltCards();
  initHeaderScroll();
  initMobileMenu();
});

function initHeaderScroll() {
  var header = document.querySelector('.et-header');
  if (!header) return;
  function update() {
    header.classList.toggle('et-scrolled', window.scrollY > 30);
  }
  update();
  window.addEventListener('scroll', update, { passive: true });
}

function initMobileMenu() {
  var btn = document.querySelector('.et-menu-btn');
  var links = document.querySelector('.et-header-links');
  if (!btn || !links) return;
  btn.addEventListener('click', function () {
    var open = links.classList.toggle('et-links-abiertos');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  links.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', function () { links.classList.remove('et-links-abiertos'); });
  });
}

function initReveal() {
  var els = document.querySelectorAll('.et-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('et-visible'); });
    return;
  }
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('et-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );
  els.forEach(function (el, i) {
    el.style.setProperty('--et-i', i % 6);
    io.observe(el);
  });
}

function initCountUp() {
  var counters = document.querySelectorAll('.et-count[data-target]');
  if (!counters.length || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        var target = parseFloat(el.getAttribute('data-target')) || 0;
        var suffix = el.getAttribute('data-suffix') || '';
        var dur = 1400;
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = target % 1 === 0 ? Math.round(target * eased) : (target * eased).toFixed(1);
          el.textContent = val + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    },
    { threshold: 0.4 }
  );
  counters.forEach(function (el) { io.observe(el); });
}

function initTiltCards() {
  var cards = document.querySelectorAll('.et-tilt');
  if (!cards.length || window.matchMedia('(pointer: coarse)').matches) return;
  cards.forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var r = card.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      card.style.transform = 'perspective(700px) rotateY(' + (x * 6) + 'deg) rotateX(' + (y * -6) + 'deg) translateY(-4px)';
    });
    card.addEventListener('mouseleave', function () {
      card.style.transform = '';
    });
  });
}
